import { requireAdmin } from "@/lib/admin-guard";
import { getSettingsForCategory } from "@/lib/settings";
import { SettingsForm } from "@/components/admin/settings-form";
import { AiTestButton } from "@/components/admin/ai-test-button";
import { updateSettingsAction } from "@/app/admin/_actions";

export const dynamic = "force-dynamic";

export default async function AdminAiSettings() {
  await requireAdmin();
  const settings = await getSettingsForCategory("ai", { unmask: false });

  return (
    <div className="space-y-2">
      <SettingsForm
        category="ai"
        title="AI Provider"
        hint="Cấu hình provider luận giải AI. DB override env. Cache 30s — đổi xong gần như tức thì."
        settings={settings}
        action={updateSettingsAction}
      />
      <AiTestButton />
    </div>
  );
}
